<app-tile-list [tiles]="tiles" (tileClicked)="tileClicked.emit($event)"></app-tile-list>
